var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"label":_vm.$t('ReceiptBillAnalyze.objType.title'),"items":_vm.objType_flgs},model:{value:(_vm.SelectModel),callback:function ($$v) {_vm.SelectModel=$$v},expression:"SelectModel"}})}
var staticRenderFns = []

export { render, staticRenderFns }